export default (fill) => (
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 137.2">
    <path fill="#D0E0E1" d="M0 12.5C0 5.6 5.6 0 12.5 0h54L100 34.1v90.7c0 6.9-6 12.5-12.9 12.5H12.5c-6.9 0-12.5-5.6-12.5-12.5V12.5z"/>
    <g fill="#6D7577">
        <path d="M15.4 91.6v-2.8h19.7v2.8h-8.2v21.8h-3.3V91.6h-8.2zM41.2 88.8v24.6H38V88.8h3.2zM62.9 88.8v2.8H50v7.8h11.3v2.8H50v11.3h-3.3V88.8h16.2zM82.7 88.8v2.8H69.8v7.8h11.3v2.8H69.8v11.3h-3.3V88.8h16.2z"/>
    </g>
    <path fill="${fill? fill : '#A1AFAF'}" d="M66.5 0v34.1H100L66.5 0z"/>
</svg>`
)


// WEBPACK FOOTER //
// ./components/Icon/icons/files/tiff.jsx